import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import insightsforteamsLogo from "../../../assets/images/logo-insights.png";
import ArrowRight from "../../../components/ui/icons/ArrowRight";
import { useProfile } from "../../auth/hooks/useProfile";
import HorizontalLayout from "../../../app/layouts/HorizontalLayout";
import WelcomeCirclesDeco from "../../../components/ui/icons/WelcomeCirclesDeco";
import ConsentModal from "./Consentmodal";
import useSurvey from "../hooks/useSurvey";

const BeginSurvey: React.FC = () => {
  const { user } = useProfile();
  const { notStarted } = useSurvey();
  const [consentOpen, setConsentOpen] = useState(false);
  const navigate = useNavigate();

  const handleAccept = () => {
    setConsentOpen(false);
    navigate("/survey");
  };

  const handleDecline = () => {
    setConsentOpen(false);
    navigate("/locker-room");
  };

  const handleClose = () => setConsentOpen(false);

  useEffect(() => {
    if (!notStarted) {
      navigate("/locker-room");
    }
  }, [notStarted, navigate]);

  return (
    <HorizontalLayout>
      <div className="sidebar:h-full flex flex-col p-2 bg-[#f1f6ff] sidebar:p-0 sidebar:pl-[42px] sidebar:bg-transparent">
        <div
          className="flex-1 flex flex-col bg-white rounded-xl sidebar:rounded-none"
          style={{ boxShadow: "0 2px 14px #0003" }}
        >
          <div className="flex flex-col bg-white font-primary rounded-xl">
            <main className="flex flex-col items-center px-6 pt-10 pb-8 text-center">
              <div className="mb-6 w-full flex justify-center">
                <div className="relative w-full max-w-[388px] min-h-[111px]">
                  <div className="sidebar:hidden">
                    <WelcomeCirclesDeco />
                  </div>
                  <div className="relative z-10 flex justify-center pt-[18px] pb-[14px]">
                    <img
                      src={insightsforteamsLogo}
                      alt="Insights for Teams"
                      className="max-w-[132px] max-h-[86px] sidebar:max-w-[253px] sidebar:max-h-[164px]"
                    />
                  </div>
                </div>
              </div>
              {/* Heading */}
              <h1 className="font-bold mb-4 text-[clamp(22px,3.5vw,32px)] text-dark-blue leading-[1.2] font-primary">
                {user?.first_name}, let's get started!
              </h1>
              {/* Description */}
              <p className="mb-8 leading-relaxed font-primary max-w-[680px] text-[clamp(14px,1.5vw,16px)] text-meta">
                In less than 20 minutes, the answers you provide on this survey
                will create a stimulating report that uncovers your personal
                preferences for teamwork and how those preferences emerge in
                your team style. Start here to help you and your team get better
                results, faster and easier.
              </p>
              <button
                onClick={() => setConsentOpen(true)}
                className="btn btn-lg btn-normal"
              >
                Begin Survey
                <span
                  className="flex items-center ml-2"
                  style={{ opacity: 0.85 }}
                >
                  <ArrowRight />
                </span>
              </button>
              <ConsentModal
                isOpen={consentOpen}
                onAccept={handleAccept}
                onDecline={handleDecline}
                onClose={handleClose}
              />
            </main>
            <footer className="border-t border-[#f0f3fa] py-5 text-center text-meta text-[14px] mt-[78px]">
              Having issues?{" "}
              <a
                href="/help"
                className="font-bold underline hover:no-underline transition-all font-primary text-blue"
              >
                Contact Technical Support
              </a>
            </footer>
          </div>
        </div>
      </div>
    </HorizontalLayout>
  );
};

export default BeginSurvey;
